import axios, { AxiosError } from 'axios';
import { ApiPromocaoResponse } from '../types/multipatrocinadores';

class MultipatrocinadorService {
  private async request<T>(
    endpoint: string,
    options: RequestInit = {}
  ): Promise<T> {
    try {
      const response = await axios.get(`${endpoint}`);
      if (!response.data) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return response.data;
    } catch (error) {
      console.error('API Error:', error);
      throw error;
    }
  }

  async searchPromocoes(
    search: string = '', 
    offset: number = 0, 
    limit: number = 50,
    idDistribuidor: string = '',
    tipo: string = ''
  ): Promise<ApiPromocaoResponse> {
    const params = new URLSearchParams({
      ...(search && { search }),
      ...(idDistribuidor && { IDDistribuidor: idDistribuidor }),
      ...(tipo && { Tipo: tipo }),
      offset: offset.toString(),
      limit: limit.toString(),
    });

    return this.request<ApiPromocaoResponse>(`/multipatrocinadores?${params.toString()}`);
  }

  async getDistributors(): Promise<any> {
    return this.request<any>('/multipatrocinadores/distributors');
  }

  async getTypes(): Promise<any> {
    return this.request<any>('/multipatrocinadores/types');
  }

  async getBUs(): Promise<any> {
    return this.request<any>('/multipatrocinadores/bu');
  }

  async getEANs(promocaoId: string): Promise<any> {
    return this.request<any>(`/multipatrocinadores/ean/${promocaoId}`);
  }

  async getSavedPromocoes(
    search: string = '', 
    offset: number = 0, 
    limit: number = 50
  ): Promise<any> {
    const params = new URLSearchParams({
      ...(search && { search }),
      offset: offset.toString(),
      limit: limit.toString(),
    });

    return this.request<any>(`/multipatrocinadores/saved?${params.toString()}`);
  }

async saveConfiguration(promocaoId: string, configuration: any): Promise<any> {
  try {
    const response = await axios.post(
      `/multipatrocinadores/${promocaoId}`,
      configuration
    );

    return {
      success: true,
      data: response.data
    };

  } catch (err) {
    const error = err as AxiosError<any>;

    console.error('API Error:', error.response?.data || error.message);

    return {
      success: false,
      error:
        error.response?.data?.message || // <-- mensagem vinda do backend
        error.response?.data?.error ||   // caso use outro padrão
        error.message ||                 // erro genérico axios
        'Erro desconhecido'
    };
  }
}

async validate(promocaoId: string, configuration: any): Promise<any> {
  try {
    const response = await axios.post(
      `/multipatrocinadores/validation/${promocaoId}`,
      configuration
    );

    return {
      success: true,
      data: response.data
    };

  } catch (err) {
    const error = err as AxiosError<any>;

    console.error('API Error:', error.response?.data || error.message);

    return {
      success: false,
      error:
        error.response?.data?.message || // <-- mensagem vinda do backend
        error.response?.data?.error ||   // caso use outro padrão
        error.message ||                 // erro genérico axios
        'Erro desconhecido'
    };
  }
}

  async getHistory(
    limit: number = 50,
    offset: number = 0,
    idRegraPromocao?: string
  ): Promise<any> {
    const params = new URLSearchParams({
      limit: limit.toString(),
      offset: offset.toString(),
      ...(idRegraPromocao && { idRegraPromocao }),
    });

    return this.request<any>(`/multipatrocinadores/history?${params.toString()}`);
  }

  async getPromocaoHistory(idRegraPromocao: string): Promise<any> {
    return this.request<any>(`/multipatrocinadores/${idRegraPromocao}/history`);
  }

  async getPromocaoHistoryDiff(idRegraPromocao: string): Promise<any> {
    return this.request<any>(`/multipatrocinadores/${idRegraPromocao}/history/diff`);
  }
}

export const multipatrocinadorService = new MultipatrocinadorService();